import * as React from "react";
import { SVGProps, memo } from "react";

const SvgClock = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={21} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.613 11.42a.75.75 0 0 1-.43-.679V7.515a.75.75 0 0 1 1.5 0v2.794l1.446.835a.75.75 0 0 1-.75 1.3l-1.705-.985a.778.778 0 0 1-.061-.04Z"
      fill="#637182"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 10.5a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-1.5 0a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Z"
      fill="#637182"
    />
  </svg>
);

const Memo = memo(SvgClock);

export default Memo;
